"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_WAREHOUSE = void 0;
var CREATE_WAREHOUSE = {
  INPUT__NAME: 'supplierCreateWarehouseModal-input-name',
  INPUT__STREET: 'supplierCreateWarehouseModal-input-street',
  INPUT__CITY: 'supplierCreateWarehouseModal-input-city',
  INPUT__ZIP_CODE: 'supplierCreateWarehouseModal-input-zipCode',
  INPUT__COUNTRY: 'supplierCreateWarehouseModal-input-country',
  INPUT__STATE: 'supplierCreateWarehouseModal-input-state',
  INPUT__CONTACT_NAME: 'supplierCreateWarehouseModal-input-contactName',
  INPUT__EMAIL: 'supplierCreateWarehouseModal-input-email',
  INPUT__PHONE: 'supplierCreateWarehouseModal-input-phone',
  BUTTON__IS_PRIMARY: 'supplierCreateWarehouseModal-button-isPrimary',
  BUTTON__REMOVE_LOCATION: 'supplierCreateWarehouseModal-button-removeLocation',
  INPUT__LOCATION_NAME: 'supplierCreateWarehouseModal-input-locationName',
  BUTTON__ADD_LOCATION: 'supplierCreateWarehouseModal-button-addLocation',
  BUTTON__CANCEL: 'supplierCreateWarehouseModal-button-cancel',
  BUTTON__CREATE: 'supplierCreateWarehouseModal-button-create'
};
exports.CREATE_WAREHOUSE = CREATE_WAREHOUSE;